import { Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";
import React, { useState } from "react";
import SlidingPanel from "react-sliding-side-panel";

interface Props {
    open_status: boolean;
    attrName: any;
    value_update: Function;
}

const ViewDocuments: React.FC<Props> = ({
    open_status,
    attrName,
    value_update,
}) => {
    const [pageStatus, setPageStatus] = React.useState<number>(1);
    const [insurer, setInsurer] = React.useState("");
    const [policy, setPolicy] = React.useState("");
    const [clientid, setClientId] = React.useState("");
    const [employeeid, setEmployeeId] = React.useState("");
    const [insuredPersonHospitalized, setInsuredPersonHospitalized] = React.useState("");
    const [state, setState] = React.useState("");
    const [hospitalName, setHospitalName] = React.useState("");
    const [city, setCity] = React.useState("");
    const [admissionDate, setAdmissionDate] = React.useState<Date | null>(null);
    const [dischargeDate, setDischargeDate] = React.useState<Date | null>(null);
    const [reasonForHospitalization, setReasonForHospitalization] = React.useState("");
    const [attachFir, setAttachFir] = React.useState(false);
    const [kycDocumentStatus, setKycDocumentStatus] = React.useState("kyc");
    const [documentStatus, setDocumentStatus] = React.useState(0);
    const [addDocumentField, setAddDocumentField] = useState<
        Array<{
            add_field: string;
        }>
    >([{ add_field: "" }]);
    const [file, setFile] = useState()

    function handleChange(event: any) {
        setFile(event.target.files[0])
    }
    // const [fileNameData,setFileNameData] = useState

    const updateMasterState = (
        attrName: any,
        value: string | boolean | number
    ) => {
        attrName(value);
    };
    const client_id_data = [
        { label: "CLID3232", value: "CLID3232" },
        { label: "CLID3233", value: "CLID3233" },
        { label: "CLID3234", value: "CLID3234" },
        { label: "CLID3235", value: "CLID3235" },
        { label: "CLID3236", value: "CLID3236" },
        { label: "CLID3237", value: "CLID3237" },
    ];
    const employee_id_data = [
        { label: "EV 3232", value: "EV 3232" },
        { label: "EV 3233", value: "EV 3233" },
        { label: "EV 3234", value: "EV 3234" },
        { label: "EV 3235", value: "EV 3235" },
        { label: "EV 3236", value: "EV 3236" },
        { label: "EV 3237", value: "EV 3237" },
    ];
    const policy_data = [
        { label: "Car", value: "Car" },
        { label: "Bike", value: "Bike" },
        { label: "Health", value: "Health" },
        { label: "Term", value: "Term" },
        { label: "Investment", value: "Investment" },
        { label: "Travel", value: "Travel" },
    ];
    const insurer_data = [
        { label: "Reliance", value: "Reliance" },
        { label: "Go Digit ", value: "Go Digit " },
        { label: "Star", value: "Star" },
        { label: "Religare", value: "Religare" },
        { label: "Chola Mandlam", value: "Chola Mandlam" },
    ];
    const insuredPersonHospitalized_data = [
        { key: "Reliance", value: "Reliance" },
        { key: "Go Digit ", value: "Go Digit " },
        { key: "Star", value: "Star" },
        { key: "Religare", value: "Religare" },
        { key: "Chola Mandlam", value: "Chola Mandlam" },
    ];
    const state_data = [
        { label: "Chandigarh", value: "Chandigarh" },
        { label: "Delhi ", value: "Delhi" },
        { label: "Himachal pradesh", value: "Himachal pradesh" },
        { label: "Haryana", value: "Haryana" },
        { label: "Punjab", value: "Punjab" },
    ];
    const city_data = [
        { label: "Mohali", value: "Mohali" },
        { label: "Shimla ", value: "Shimla" },
        { label: "Dharamshala", value: "Dharamshala" },
        { label: "Panchkula", value: "Panchkula" },
    ];

    const changePageStatus = (status: boolean) => {
        if (status === true) {
            if (pageStatus < 2) {
                setPageStatus(pageStatus + 1);
            }
        } else {
            if (pageStatus > 1) {
                setPageStatus(pageStatus - 1);
            }
        }
    };

    return (
        <SlidingPanel
            type={"right"}
            isOpen={open_status}
            size={75}
            panelClassName="sliding-panel"
        // backdropClicked={() => value_update(attrName, false)}
        >
            <div>
                <Grid container spacing={3} alignItems="center">
                    <Grid xs={10}>
                        <h4 className="mb-0 mt-3">Documents</h4>
                    </Grid>
                    <Grid xs={2} textAlign='end' className="mt-3">
                        <GridCloseIcon
                            onClick={() => {
                                value_update(attrName, false);
                            }}
                        />
                    </Grid>
                    <Grid xs={12} className="pt-0">
                        <hr />
                    </Grid>
                </Grid>
                <div>
                    <Grid container spacing={2} className="mt-4 mb-2" alignItems={'center'}>
                        <Grid xs={9}>
                            <p className="fileName_text">Leagal FIR.jpg</p>
                        </Grid>
                        <Grid xs={3} textAlign={'end'}>
                            <Link
                                className="blueBtn download ml-0"
                                sx={{
                                    textDecoration: "none",
                                    cursor: "pointer",
                                }}
                            ></Link>
                        </Grid>
                        <Grid xs={12}>
                            <hr />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} className="mb-2">
                        <Grid xs={9}>
                            <p className="fileName_text">Surgery_Hospital_Bill.pdf</p>
                        </Grid>
                        <Grid xs={3} textAlign={'end'}>
                            <Link
                                className="blueBtn download ml-0"
                                sx={{
                                    textDecoration: "none",
                                    cursor: "pointer",
                                }}
                            ></Link>
                        </Grid>
                        <Grid xs={12}>
                            <hr />
                        </Grid>
                    </Grid>
                </div>

            </div>
        </SlidingPanel>
    );
};

export default ViewDocuments;
